import styled from "styled-components"

export const ContentCalloutDIV = styled.div`
  background: rgba(var(--color--slate-600-rgb), 0.075);
  border-radius: var(--border-radius--M);
  margin: var(--spacing--S) 0 var(--spacing--M);
  max-width: 100%;
  padding: var(--spacing--base-2-5) var(--spacing--base-2-5) var(--spacing--base-2);


  .content {
    p {
      color: var(--Content--text-color);
    }

    &
    > h1,
    > h2,
    > h3,
    > h4,
    > h5 {
      &:first-of-type {
        margin-top: 0;
      }
    }

    h2 {
      font-size: var(--font-size--2XL);
      font-weight: var(--font-weight--medium);
    }

    h3 {
      font-size: var(--font-size--XL);
      font-weight: var(--font-weight--medium);
    }

    h4 {
      font-size: var(--font-size--L);
      font-weight: var(--font-weight--medium);
    }

    h5 {
      font-size: var(--font-size--M);
      font-weight: var(--font-weight--medium);
    }

    blockquote {
      margin: 0;
    }

    p:last-child {
      margin-bottom: 0;
    }

    strong,
    b, p b {
      color: var(--Content--text-dark-color);
      font-weight: var(--font-weight--medium);
    }

    ol, ul {
      margin-top: 20px;
      
      &:last-child {
        margin-bottom: 0;
      }
    }
    
    .Button {
      display: block;
      margin: 20px 0;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .AvatarWithName {
    margin-top: var(--spacing--base-1-5);
  }
`
